<template>
  <div>
    <!--
    <table width='100%' class='table' v-if='data && data.length'>
      <tr>
        <th width='10%' class='colTitle'>{{ $t("Env") }}</th>
        <th width='25%' class='colTitle'>{{ $t("Client") }}</th>
        <th width='10%' class='colTitle'>{{ $t("Exposure") }}</th>
        <th width='10%' class='colTitle'>{{ $t("P&L") }}</th>
        <th width='10%' class='colTitle'>{{ $t("Equity") }}</th>
        <th width='10%' class='colTitle'>{{ $t("Used Margin") }}</th>
        <th width='10%' class='colTitle'>{{ $t("Volume") }}</th>
        <th width='12%' class='colTitle'>{{ $t("Ticket Count") }}</th>
      </tr>
      <tr class='lu-click' v-for='(cli, index) in data' :key='index'  v-if='index < count' @dblclick='getDetail(cli.accountName)'>
        <td class='rowTitle'>{{ cli.brokerName }}</td>
        <td class='rowTitle'>{{ cli.accountName }}</td>
        <td :class='cli.exposure >= 0 ? "positive" : "negative"' class='rowData'>{{ cli.exposure | formatAmount }}</td>
        <td :class='cli.profitAndLoss >= 0 ? "positive" : "negative"'  class='rowData' >{{ cli.profitAndLoss | formatAmount }}</td>
        <td :class='cli.AccountEquity >= 0 ? "positive" : "negative"'  class='rowData' >{{ cli.AccountEquity | formatAmount }}</td>
        <td class='rowData'>{{ cli.usedMarginPerc | formatPercent }}</td>
        <td :class='cli.volume >= 0 ? "positive" : "negative"'  class='rowData' >{{ cli.volume | formatAmount }}</td>
        <td class='rowData' >{{ cli.ticketCount | formatCount }}</td>
      </tr>
    </table>
    <el-table :data='tableData' class='riskTable' :height="panelHeight" style='width: 100%' fit
          :cell-class-name = "() => 'lu-click'"
          @row-dblclick='row => getDetail(row.instrumentName)'

    -->
    <el-table
      ref='risktable'
      class='riskTable'
      :data="data"
      :cell-class-name = "() => 'lu-click'"
      :height="parentPanelHeight"
      fit
      style="width: 100%;"
      :row-class-name="tableRowClassName"
      @row-dblclick='row => getDetail(row.brokerName,row.accountNumber,row.accountName)'
    >
      <el-table-column :label="$t('Env')" sortable prop='brokerName' align="left" />
      <el-table-column :label="$t('Book')" sortable prop='bookName' align="left"  />
      <!-- <el-table-column :label="$t('Book')" sortable prop='bookName' align="left"  min-width='120'  :render-header="renderSelectHeader"/> -->
      <el-table-column :label="$t('Client')" sortable prop='accountName' align="left"  min-width='120'  />
      <el-table-column :label="$t('Account')" sortable prop='accountNumber' align="left" />
      <el-table-column :label="$t('Exposure')" sortable prop='exposure' :sort-method='(a,b) => sortFloat(a,b,"exposure")' align="left" >
        <template slot-scope="scope">
          <div style='text-align: right' :class='scope.row.exposure >= 0  ? "positive" : "negative"'>{{ scope.row.exposure | formatAmount }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('P&L')" sortable prop='profitAndLoss' :sort-method='(a,b) => sortFloat(a,b,"profitAndLoss")' align="center">
        <template slot-scope="scope">
          <div style='text-align: right' :class='scope.row.profitAndLoss >= 0  ? "positive" : "negative"'>{{ scope.row.profitAndLoss | formatAmount }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('Equity')" sortable prop='AccountEquity' :sort-method='(a,b) => sortFloat(a,b,"AccountEquity")' align="center">
        <template slot-scope="scope">
          <div style='text-align: right' :class='scope.row.AccountEquity >= 0  ? "positive" : "negative"'>{{ scope.row.AccountEquity | formatAmount }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('Used Margin')" sortable prop='usedMarginPerc' :sort-method='(a,b) => sortFloat(a,b,"usedMarginPerc")' align="center">
        <template slot-scope="scope">
          <div style='text-align: right'>{{ scope.row.usedMarginPerc | formatPercent }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('Volume')" sortable prop='volume' :sort-method='(a,b) => sortFloat(a,b,"volume")' align="center">
        <template slot-scope="scope">
          <div style='text-align: right' :class='scope.row.volume >= 0 ? "positive" : "negative"'> {{ scope.row.volume | formatAmount }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('Ticket Count')" sortable prop='ticketCount' :sort-method='(a,b) => sortFloat(a,b,"ticketCount")' align="center">
        <template slot-scope="scope">
          <div style='text-align: right'>{{ scope.row.ticketCount | formatCount }}</div>
        </template>
      </el-table-column>
    </el-table>

  </div>
</template>

<script>
import utils from '@/utils/formatNumber'
import monitoringMixin from './mixins'

export default {
  name: 'ClientArray',
  props: [ 'data', 'parentPanel', 'panel' ],
  mixins: [ monitoringMixin ],
  filters: {
    formatAmount: function (value) {
      return utils.formatAmount(value || 0, 2, 3)
    },
    formatCount: function (value) {
      return utils.formatNumber(value || 0, 0)
    },
    formatPercent: function (value) {
      return (value || 0) + ' %'
    }
  },
  watch: {
    data: {
      handler () {
        this.updateLayout()
      },
      immediate: true
    }
  },
  // data() {
  //   return {
  //     dialog: {
  //         visible: false,
  //         loading: false,
  //     },
  //     expense: {
  //         date: null,
  //         items: [],
  //         new_item: { date: null, type: null }
  //     },
  //     expenses: [],
  //     expenses_ref: null,
  //     expense_types: [
  //       { value: 'MT4 winners', name: 'MT4 winners'},
  //       { value: 'MT4 loosers', name: 'MT4 loosers'},
  //       { value: 'CIB', name: 'CIB'}
  //     ]
  //   }
  // },
  methods: {
    getDetail: function (brokerName, accountNumber, label) {
      let params = [
        {'paramName': 'origin', 'paramValue': this.panel.id},
        {'paramName': 'platform', 'paramValue': brokerName},
        {'paramName': 'accountNumber', 'paramValue': accountNumber},
        {'paramName': 'account', 'paramValue': label}
      ]
      // this.$store.dispatch('settingsMonitor/changeDetailParams', {title: this.panel.options.title, type: 'account', value: label, params: params, show: true})
      this.$emit('getDetail', {title: this.panel.options.title, type: 'account', value: label, params: params, show: true})
    },
    updateLayout() {
      if (this.$refs.risktable && this.$refs.risktable.doLayout) {
          this.$refs.risktable.doLayout()
      }
    }
    // renderSelectHeader(createElement, { column, store }) {
    //   let element = createElement('div', { class: 'el-table-header-resource' }, [
    //     createElement('el-select', {
    //       props: { placeholder: column.label, value: this.expense.new_item[column.property]},
    //       on: {
    //         input: (value) => {
    //           this.expense.new_item[column.property] = value
    //         }
    //       }
    //     }, this.expense_types.map((item) => {
    //       return createElement('el-option', {props: { key: item.value, value: item.value, label: item.name}})
    //     }))
    //   ])

    //   element.fnScopeId = this.$options._scopeId;
    //   element.fnContext = this;

    //   return element;
    // }
  }
}
</script>

<style scoped>
</style>